import React, { Component } from 'react';
import { connect } from "react-redux";
import './header.css';

import { loginClicked, profileClicked, presentClicked, employeesClicked, followUpClicked, settingsClicked } from '../../../redux/actions';
import { loggedInUser, newHighFivesCount } from '../../../redux/selectors'
import ProfilePic from '../../atoms/profilePic/profilePic';

class Header extends Component {
  renderNotif() {
    const { user, newHighFivesCount } = this.props;
    if(newHighFivesCount) {
      return (
        <div className='clickable' onClick={() => this.props.presentClicked()}>
          <span className='mdi mdi-gift active' />
          <span className="notifNumber mdi mdi-circle-medium" />
        </div>
      )
    } else {
      return (
        <div className='clickable'>
          <span className='mdi mdi-gift' onClick={() => this.props.presentClicked()} />
        </div>
      )
    }
  }
  renderAdmin() {
    const { user } = this.props;
    if(user.admin) {
      return (
        <div className='clickable'>
          <span className='mdi mdi-account-multiple' onClick={() => this.props.employeesClicked()} />
          <span className='mdi mdi-emoticon' onClick={() => this.props.followUpClicked()} />
          <span className='mdi mdi-settings-outline' onClick={() => this.props.settingsClicked()} />
        </div>
      )
    } else { return null }
  }
  render() {
    const { user } = this.props;

    if(!user || !user.loggedIn) {
      return <div id='header' className='container'><p className='clickable hoverVisible' onClick={() => this.props.loginClicked()}>Login</p></div>
    } else {
      return (
        <div id='header' className='container'>
          <p className='bold clickable' onClick={() => this.props.profileClicked()}>{user.email}</p>
          {/* <p className="mdi mdi-circle-medium" />
          <p>9 cubics</p> */}
          <ProfilePic size='small' clickable='true' employee={user} onClick={() => this.props.profileClicked()} />
          {this.renderNotif()}
          {this.renderAdmin()}
        </div>
      )
    }
  }
}

export default connect(state => ({user: loggedInUser(state), newHighFivesCount: newHighFivesCount(state)}), { loginClicked, profileClicked, presentClicked, employeesClicked, followUpClicked, settingsClicked })(Header);
